export class StrutturaFascicoloVO {
    cmu: string;
    nome: string;
}